module.exports = __webpack_public_path__ + "static/media/jackpot-mobile.b7da6d5e.svg";